export default __webpack_public_path__ + "static/media/video.93e5dd0d.mp4";